import { getDocs } from 'firebase/firestore';
import { getOrganizationFirestore } from '../../resources/orgFirebase';
import FirebaseManager from '../Firebase/FirebaseManager';

export default class BookingItemManager {
	static isLoading = false;
	static allBookings = [];

	static getAllBooking() {
		return new Promise((resolve, reject) => {
			this.allBookings = [];
			this.isLoading = true;
			const firestore = getOrganizationFirestore();
			const bookingRef = FirebaseManager.allBookingRef(firestore);
			getDocs(bookingRef)
				.then((snapshot) => {
					if (!snapshot.empty) {
						const documents = snapshot.docs;
						const total = documents.length;
						var counter = 0;
						documents.forEach((document) => {
							const documentData = document.data();
							if (
								!this.allBookings.find(($0) => $0.bookingId == documentData.bookingId)
							) {
								this.allBookings.push(documentData);
							}
							if (counter == total - 1) {
								this.isLoading = false;
								return resolve();
							}
							counter += 1;
						});
					} else {
						this.isLoading = false;
						return resolve(null);
					}
				})
				.catch((error) => {
					console.log(error.message);
					this.isLoading = false;
					return resolve(null);
				});
		});
	}

	static getAllBookingTypes() {
		return new Promise((resolve, reject) => {
            this.allBookingTypes = [];
			this.isLoading = true;
			const firestore = getOrganizationFirestore();
			const bookingTypesRef = FirebaseManager.bookingTypeInformationRef(firestore)
			getDocs(bookingTypesRef).then((snapshot) => {
					if (!snapshot.empty) {
						const documents = snapshot.docs;
						const total = snapshot.size;
						var counter = 0;
						var items = [];
						documents.forEach((document) => {
							const documentData = document.data();
							items.push(documentData);
							if (counter == total - 1) {
								this.isLoading = false;
								return resolve(items);
							}
							counter += 1;
						});
					} else {
						this.isLoading = false;
						return resolve(null);
					}
				})
				.catch((error) => {
					this.isLoading = false;
					return resolve(null);
				});
        })
    }

}
